import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';

import {AuthenticationService} from '../services/authentication.service';

import {Role} from '@models/roles.enum';
import {Log} from "ng2-logger";
import {PermissionService} from "@app/authentication/services/permission.service";
import {SidebarVisibilityService} from "@app/core/services/sidebar-visibility.service";
import {UserBusinessType} from "@app/shared/models/enums/user-business-type.enum";

/**
 * Guard class for allowing access only for users with the {@link Role} of atom operator
 */
@Injectable()
export class IntroGuard implements CanActivate {
    _logger = Log.create(IntroGuard.name);

    constructor(private router: Router,
                private authenticationService: AuthenticationService,
                private permissionService: PermissionService,
                private sidebarVisibilityService: SidebarVisibilityService) {
    }

    canActivate() {
        const isAllowedLogin = this.authenticationService.isAllowedLogin();
        this._logger.info('canActivate:: Is allowed login', isAllowedLogin);
        if (!isAllowedLogin) {
            // JWT is missing required fields (boschId/role)
            // Clear the invalid token and redirect to legacy login to prevent redirect loop
            localStorage.removeItem('user_token');
            this.authenticationService.setLegacyAuthRequired(true);
            this.router.navigate(['/auth/login'], {queryParams: {legacyAuth: true}});
            return false;
        }

        const currentUser = this.authenticationService.getUserDetails();
        if (currentUser?.userBusinessType === UserBusinessType.TechnicalToolManagementUser) {
            this.router.navigate(['/dashboard']);
            return false;
        }

        if (currentUser?.userBusinessType === UserBusinessType.TechnicalProductionUser) {
            this.router.navigate(['/scan-badge']);
            return false;
        }

        const isCurrentUserMilkrun = this.authenticationService.isCurrentUserWithRole(Role.MILKRUN_OPERATOR);
        this._logger.info('canActivate:: Is current user with role', Role.MILKRUN_OPERATOR, isCurrentUserMilkrun);
        if (isCurrentUserMilkrun) {
            this.router.navigate(['/transportation-requests']);
            return false;
        }

        const isCurrentUserService = this.authenticationService.isCurrentUserWithRole(Role.SERVICE_OPERATOR);
        this._logger.info('canActivate:: Is current user with role', Role.SERVICE_OPERATOR, isCurrentUserService);
        if (isCurrentUserService) {
            this.router.navigate(['/service-tickets'], {queryParams: {type: 'all'}});
            return false;
        }
        const hasToolSection = this.permissionService.hasSectionClaim(currentUser, 'TOOLMANAGEMENT');
        const hasStrainSection = this.permissionService.hasSectionClaim(currentUser, 'STRAIN');
        const hasStoredSectionSelection = this.sidebarVisibilityService.hasStoredSelection();

        if (hasToolSection && hasStrainSection && !hasStoredSectionSelection) {
            this.router.navigate(['/section-selection']);
            return false;
        }

        return true;
    }
}
